import React from 'react';

import SettingsPage from '../../containers/Settings';

import Layout from '$/components/elements/Layout';
import Providers from '$/components/elements/Layout/Providers';

export interface ISettingsPageProps {}

const Settings = (props: ISettingsPageProps) => (
  <Providers>
    <Layout {...props} showFooter>
      <SettingsPage {...props} />
    </Layout>
  </Providers>
);

export default Settings;
